module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Ton2.22f9140f.png";